import { render, staticRenderFns } from "./numslide_input.vue?vue&type=template&id=76a9443c&scoped=true&"
import script from "./numslide_input.vue?vue&type=script&lang=js&"
export * from "./numslide_input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a9443c",
  null
  
)

export default component.exports
import QSlider from 'quasar/src/components/slider/QSlider.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSlider,QBtn});
